import { parent } from 'utils'
import { returnToCookieName } from 'utils/config'
import LzCookies from 'utils/lz_cookies'
import { CLEVER as config } from 'environment'
import { HTTP } from 'vue_features/shared/helpers/http_helper'

export function instantLogin(loginUrl, options = {}) {
  const clientId = options.clientId || config.clientId

  HTTP.fetch(config.authenticatedUrl, {
    headers: { 'Content-Type': 'application/json', 'X-Client-ID': clientId },
    credentials: 'include',
  })
    .then((resp) => resp.json())
    .then((data) => {
      if (data.authenticated) {
        if (options.returnTo) LzCookies.set(returnToCookieName, options.returnTo, { domain: '' })
        parent.postMessage({ message: 'authenticated', url: loginUrl }, '*')
      }
    })
}
